module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9kNgsR/tc-custom/9781644033708.jpg?1734695126519",
      "alt": "This image is the cover for the book Instant Softies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Instant Softies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sweet, simple softies in three easy steps Everyone can make softies with this simple three-step method perfect for complete beginners and avid crafters. Sew any of seven animals, including a bear, fox, elephant, or mouse! Plus, add accessories to bring out their unique and adorable personalities. Give your handmade stuffed animal a bow and hat for a dashing look or a scarf and bag for a cold and windy day. This is a simple craft for anyone to enjoy; the only hard part is deciding which softie to make next!.   Mix and match outfits to give each softie a unique personality. Softies make lovely, thoughtful gifts and can be sewn up in a matter of hours  The 3 pattern piece, 3-step system is perfect for crafters who want a project they can learn and complete, even without much experience")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Isabelle Ewing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Isabelle Ewing has always had a lifelong love of drawing, painting, and sewing. She lives in Northern Ireland, just outside of Belfast, where she has sold artwork to local shops and the beautiful Victorian St. Georges market in the city's heart.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Published by C&T Publishing, Inc.,\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0